/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_Step_2Inputs */

const en_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They enter your invite code`)
};

const ar_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يدخلون رمز الدعوة الخاص بك`)
};

const de_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie geben deinen Einladungscode ein`)
};

const es_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ellos introducen tu código de invitación`)
};

const fr_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ils saisissent votre code d’invitation`)
};

const it_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inseriscono il tuo codice invito`)
};

const ja_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相手があなたの招待コードを入力する`)
};

const ko_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상대방이 내 초대 코드를 입력해요`)
};

const pt_br_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elas inserem seu código de convite`)
};

const ru_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Они вводят ваш код приглашения`)
};

const th_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พวกเขากรอกรหัสเชิญของคุณ`)
};

const tr_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet kodunu girerler`)
};

const zh_cn_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对方输入你的邀请码`)
};

const zh_tw_invite_page_step_2 = /** @type {(inputs: Invite_Page_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`對方輸入你的邀請碼`)
};

/**
* | output |
* | --- |
* | "They enter your invite code" |
*
* @param {Invite_Page_Step_2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_step_2 = /** @type {((inputs?: Invite_Page_Step_2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_Step_2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_step_2(inputs)
	if (locale === "ar") return ar_invite_page_step_2(inputs)
	if (locale === "de") return de_invite_page_step_2(inputs)
	if (locale === "es") return es_invite_page_step_2(inputs)
	if (locale === "fr") return fr_invite_page_step_2(inputs)
	if (locale === "it") return it_invite_page_step_2(inputs)
	if (locale === "ja") return ja_invite_page_step_2(inputs)
	if (locale === "ko") return ko_invite_page_step_2(inputs)
	if (locale === "pt_br") return pt_br_invite_page_step_2(inputs)
	if (locale === "ru") return ru_invite_page_step_2(inputs)
	if (locale === "th") return th_invite_page_step_2(inputs)
	if (locale === "tr") return tr_invite_page_step_2(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_step_2(inputs)
	return zh_tw_invite_page_step_2(inputs)
});